export const SYSTEM_ADVISOR_REF = "AAAAAAAAAAA=";

export type AddressForm = {
  street1?: string;
  street2?: string;
  city?: string;
  state?: string;
  zipCode?: string;
};
